import Views from "@/views";
import Layout from "@/components/Layouts/Index.vue";

/* Views */
const { saberTypesView, saberWeightsView, AcademicPerformanceGrades, Competencies,CompetencyTabContent } = Views;

const academicBaseRouter = {
  path: "/base-academic",
  component: Layout,
  redirect: "dashboard",
  name: "",
  history: false,
  meta: {
    requiresAuth: true,
  },
  children: [
    {
      path: "saber-types",
      name: "SaberTypes",
      component: saberTypesView,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "percent-saberes",
      name: "PercentSaberes",
      component: saberWeightsView,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "grades-performance",
      name: "grades-performance",
      component: AcademicPerformanceGrades,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "competencies",
      name: "competencies",
      component: Competencies,
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "competencies-tab-content/:Id?",
      name: "CompetenciesTabContent",
      component: CompetencyTabContent,
      meta: {
        requiresAuth: true,
      },
    },
  ],
};

export default academicBaseRouter;
